// extracted by css-extract-rspack-plugin
export default {"cls1":"PostImage-cls1_2Do","cls2":"PostImage-cls2_i8k PostImage-cls1_2Do","border":"PostImage-border_qNS"};